import React from 'react';
import { Button, Icon, IconProps, IconNames, IconSizes } from '@dotcom/crown-ui';
import classNames from 'classnames';
import { LoadingButtonProps } from './loading-button-types';
import styles from './loading-button.module.scss';

export const LoadingButton = ({
  isLoading,
  loadingText,
  isIconSpinning = true,
  loadingIconName = IconNames.SyncSyncInactive,
  defaultText,
  testId = 'loading-button',
  click,
  addClass = '',
}: LoadingButtonProps): React.ReactElement => {
  const classes = classNames(
    styles['loading-button'],
    isIconSpinning && styles['loading-button--icon-spinning'],
    addClass,
  );

  const loadingIcon: IconProps = {
    name: loadingIconName,
    color: isLoading ? 'disabled' : 'blue',
    className: classNames(
      isLoading ? styles['loading-icon'] : styles['loading-icon--inactive'],
      isIconSpinning && styles['loading-icon--spinning'],
    ),
    size: '12',
  };

  return (
    <Button className={classes} variant="link" onClick={click} testId={testId} type="button" disabled={isLoading}>
      <Icon
        name={loadingIcon.name}
        color={loadingIcon.color}
        className={loadingIcon.className}
        size={loadingIcon.size as IconSizes}
        altText="THiS IS MY ALT TEXT"
      />
      {isLoading ? loadingText : defaultText}
    </Button>
  );
};
